import React from 'react';
import SelectField from '../../../Dropdown/select/SelectField';
var DropdownInput = React.forwardRef(function (_a, ref) {
    var id = _a.id, label = _a.label, isLabelHidden = _a.isLabelHidden, items = _a.items, wrapperClassName = _a.wrapperClassName, value = _a.value, onSelect = _a.onSelect;
    var itemsWithSelected = items.map(function (item) {
        return {
            label: item.label || '',
            value: item.value || '',
            selected: item.value === value,
        };
    });
    return (React.createElement(SelectField, { id: id, label: label, isLabelHidden: isLabelHidden, className: wrapperClassName, onSelect: onSelect, items: itemsWithSelected }));
});
DropdownInput.displayName = 'DropdownInput';
export default DropdownInput;
//# sourceMappingURL=DropdownInput.js.map